/**
 * Centralized configuration constants
 * All environment variables should be accessed through this file
 */

// Contact information
export const CONTACT_EMAIL: string =
  process.env.REACT_APP_CONTACT_EMAIL || "skystanoyevitch@proton.me";
export const GITHUB_URL: string =
  process.env.REACT_APP_GITHUB_URL || "https://github.com/skystanoyevitch";

// Site metadata
export const SITE_NAME: string = "Sky Stanoyevitch Portfolio";
export const SITE_URL: string = "https://skystanoyevitch.com";
